module.exports = __webpack_public_path__ + "img/t4-i8.5886d268.jpg";